import { useCallback } from "react";
import { apiClient, StatusEnum } from "../../shared";
import { CustomAutocomplete } from "../../ui";

export const ExpenseCategorySelect = (props) => {
  const fetchExpenseCategories = useCallback(async () => {
    const {
      data: { data },
    } = await apiClient.get("expense-categories", {
      params: {
        status: StatusEnum.ACTIVE,
      },
    });
    return data;
  }, []);

  return (
    <CustomAutocomplete
      fetchOptions={fetchExpenseCategories}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, selectedOption) =>
        option.id === selectedOption.id
      }
      {...props}
    />
  );
};
